import { get, post } from '../../utils/http'

const user_detail = JSON.parse(localStorage.getItem('user_detail')) || {user_id: 0};

export  const getPurposeSchoolAndSpecialty =(type)=>get(`/xbag/college/purpose/get2?user_id=${Number(user_detail.student.userId)}&type=${type||1}`);//获取意向专业+学校

export  const saveSchool =(schoolIds,type)=>post(`/xbag/college/purpose/university/save/${schoolIds}?user_id=${Number(user_detail.student.userId)}&type=${type||1}`);//保存学校

export const clearSchoolIntention = (type) => post(`/xbag/college/purpose/university/clear?user_id=${Number(user_detail.student.userId)}&type=${type||1}`, {});//清除意向学校




// WEBPACK FOOTER //
// ./src/api/schoolWishList/index.js